import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../../ui';

/**
 * A tile that is one link. It owns what an anchor would otherwise take from
 * Bootstrap (link ink, underline) and the lift on hover, which stays still for
 * anyone who asked for less motion. The tile's own shape comes in `className`.
 */
const TileLink = ({ className, ...props }) => (
  <Link
    className={cn(
      'tw-text-content tw-no-underline tw-transition-[box-shadow,transform,border-color]',
      'hover:tw--translate-y-0.5 hover:tw-text-content hover:tw-shadow-card-hover',
      'tw-focus-ring motion-reduce:hover:tw-translate-y-0',
      className,
    )}
    {...props}
  />
);

export default TileLink;
